import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomeView from './views/Home/HomeView';
import AboutView from './views/About/AboutView';
import AiView from './views/Ai/AiView';
import CareerView from './views/Career/CareerView';
import VacancyView from './views/Career/VacancyView';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './hooks/scrollToTop';
import CookiesPolicy from './views/Cookies/CookiesPolicy';
import PrivacyPolicy from './views/Privacy/PrivacyPolicy';
import PersonalDataPolicy from './views/PersonalData/PersonalDataPolicy';
import { LocaleProvider } from './contexts/LocaleContext';
import './fonts.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <HelmetProvider>
    <LocaleProvider>
      <BrowserRouter>
        <ScrollToTop>
          <Routes>
            <Route path='/' element={<HomeView />} />
            <Route path='about' element={<AboutView />} />
            <Route path='ai' element={<AiView />} />
            <Route path='career' element={<CareerView />} />
            <Route path='career/:id' element={<VacancyView />} />
            <Route path='privacy-policy' element={<PrivacyPolicy />} />
            <Route path='cookies-policy' element={<CookiesPolicy />} />
            <Route path='personal-data-policy' element={<PersonalDataPolicy />} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </LocaleProvider>
  </HelmetProvider>
);

reportWebVitals();
